// Settings-spezifische API-Calls (Passwort, Avatar-Upload, Self-Delete).
// Ergänzt auth-api.ts; bewusst getrennt, damit auth-api schlank bleibt.

import { apiFetch, getApiBase } from './api';

export async function changePassword(
  accessToken: string,
  oldPassword: string,
  newPassword: string,
): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>('/auth/password', {
    method: 'POST',
    accessToken,
    json: { oldPassword, newPassword },
  });
}

export async function uploadAvatar(
  accessToken: string,
  file: File,
): Promise<{ avatar_url: string }> {
  const form = new FormData();
  form.append('file', file);
  // apiFetch setzt JSON-Header — für multipart nutzen wir fetch direkt,
  // damit der Browser die Boundary selbst setzt.
  const res = await fetch(`${getApiBase()}/auth/avatar`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: form,
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Upload fehlgeschlagen (HTTP ${res.status})`);
  }
  return (await res.json()) as { avatar_url: string };
}

export async function deleteAccount(accessToken: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>('/auth/account', { method: 'DELETE', accessToken });
}
